import { dateRangeStyles } from "@waytek/Overrides/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = {
    ...dateRangeStyles.datePickersWrapper,
    css: css`
        ${dateRangeStyles.datePickersWrapper?.css}

        &&& {
            width: 100%;

            > div {
                width: 50%;

                + div {
                    width: 50%;
                }
            }

            ${mediaQueriesBP.minLG} {
                .react-calendar {
                    right: 0;
                    left: unset;
                }
            }

            ${mediaQueriesBP.maxLG} {
                & > div {
                    .react-calendar {
                        left: 0;
                        right: unset;
                    }

                    & + div {
                        .react-calendar {
                            right: 0;
                            left: unset;
                        }
                    }
                }
            }

            .react-datetime-picker--enabled {
                padding: 0 0 0 12px;
            }

            span.date-picker__calendar {
                margin: 0;
            }
        }
    `,
};

dateRangeStyles.fromDate = {
    ...dateRangeStyles.fromDate,
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-right: 10px;
        `,
    },
};

dateRangeStyles.toDate = {
    ...dateRangeStyles.toDate,
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-left: 10px;
        `,
    },
};
